import { useWatch } from 'react-hook-form';
import { useCompanyContext } from '../../../context/CompanyContext';
import { POLICY_STATUS, PolicyFiltersOptions } from './PolicyFilters';

const PolicyReportHeader = () => {
  const { selectedCompany } = useCompanyContext();
  const filters = useWatch<PolicyFiltersOptions>();

  return (
    <div className="blackText printMedia printShow">
      <div className="text-30px text-center mt-5">{selectedCompany!.name}</div>
      <div className="text-28px text-center">Policy Report</div>
      <div className="text-17px ml-3 mt-2">
        <span className="font-bold text-20px">Search criteria:</span>
        <div className="ml-3">
          <div>
            <span className="font-bold mr-1">Status:</span>
            {
              POLICY_STATUS.find(
                (status) => status.value === filters.policyStatus
              )?.label
            }
          </div>
        </div>
      </div>
      <div className="ml-3 text-17px mb-5">
        <span className="font-bold mr-1">Created at:</span>
        {new Date().toLocaleString()}
      </div>
    </div>
  );
};

export default PolicyReportHeader;
